import React from "react";
import * as S from "./styles";

const BorderedInputTextCredit = ({
  type,
  name,
  label,
  width,
  height,
  radius,
  border,
  error,
  ...rest
}) => {
  return (
    <S.Container width={width}>
      <S.Wrapper>
        <S.Label className="labelInputBordered">{label}</S.Label>
        <S.Input name={name} type={type} {...rest} />
      </S.Wrapper>
      <S.LabelUnder error={error}>{error}</S.LabelUnder>
    </S.Container>
  );
};

export default BorderedInputTextCredit;
